@if(!isDateRange){
<p-datepicker [(ngModel)]="date" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
  [touchUI]="true" hideOnDateTimeSelect="false" [showOnFocus]="false" appendTo="body" #myCalendar
  panelStyleClass="datepicker-overlay-panel" [motionOptions]="{ duration: 0 }"
  (onClose)="clearCalendar()">
  <ng-template pTemplate="footer">
    <div class="col fontclass">
      <mat-divider></mat-divider>
      <div style="text-align: center; margin-bottom: -1rem;">
        <button mat-button class="cancelBtn"
          (click)="myCalendar.hideOverlay();clearCalendar()"><mat-icon>close</mat-icon>Cancel</button>
        <button mat-button (click)="myCalendar.hideOverlay();setDateChange()"
        class="setBtn"><mat-icon>check</mat-icon>Set</button>
      </div>
    </div>
  </ng-template>
</p-datepicker>
}
@if(isDateRange){
<p-datepicker appendTo="body" required name="dateRange"
  [(ngModel)]="dateRange" [iconDisplay]="'input'" [showOnFocus]="false" modal="true" [readonlyInput]="true"
  [showIcon]="true" selectionMode="range" [touchUI]="true" inputId="icondisplay" hideOnDateTimeSelect="false"
  panelStyleClass="datepicker-overlay-panel" [motionOptions]="{ duration: 0 }"
  #myCalendar (onClose)="clearCalendar()">
  <ng-template pTemplate="footer">
    <div class="col fontclass">
      <mat-divider></mat-divider>
      <p class="datefontclass">From:<span style="float: right;">{{dateRange[0] | date:
          'MM/dd/yyyy'}}</span></p>
      <mat-divider></mat-divider>
      <p class="datefontclass">To:<span style="float: right;">{{dateRange[1] | date:
          'MM/dd/yyyy'}}</span></p>
      <mat-divider></mat-divider>
      <div style="text-align: center; margin-bottom: -1rem;">
        <button mat-button class="cancelBtn"
          (click)="myCalendar.hideOverlay();clearCalendar()">
          <mat-icon>close</mat-icon> Cancel</button>
        <button mat-button (click)="myCalendar.hideOverlay();setDateChange()" #btnFocus=matButton
          class="setBtn"><mat-icon>check</mat-icon> Set</button>
      </div>
    </div>
  </ng-template>
</p-datepicker>
}